import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Box,
    Container,
    Paper,
    TextField,
    Button,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Alert,
    CircularProgress
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import authService from '../../services/authService';

const Login = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        username: '',
        password: '',
        userType: 'employee'
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const response = await authService.login(
                formData.username,
                formData.password,
                formData.userType
            );

            if (response && response.token) {
                // For employees, the backend will return their role (admin, manager, etc.)
                // For other user types, proceed as normal
                const dashboardPaths = {
                    employee: '/employee/dashboard',
                    franchise: '/franchise/dashboard',
                    customer: '/customer/dashboard'
                };

                navigate(dashboardPaths[formData.userType] || '/');
            } else {
                setError('Invalid response from server');
            }
        } catch (err) {
            setError(err.message || 'Invalid credentials');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Paper
                    elevation={3}
                    sx={{
                        padding: 4,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        width: '100%',
                    }}
                >
                    {/* Company Logo */}
                    <Box 
                        sx={{ 
                            mb: 3, 
                            textAlign: 'center',
                            '& img': {
                                height: { xs: '50px', sm: '60px' },
                                maxWidth: { xs: '180px', sm: '220px' },
                                width: 'auto',
                                objectFit: 'contain',
                                filter: 'drop-shadow(0px 2px 4px rgba(0,0,0,0.1))'
                            }
                        }}
                    >
                        <img 
                            src="/admin/assets/images/logo.png" 
                            alt="SunEx Courier" 
                            onError={(e) => {
                                e.target.style.display = 'none';
                            }}
                        />
                    </Box>
{/* 
                    <Box
                        sx={{
                            backgroundColor: 'primary.main',
                            borderRadius: '50%',
                            padding: 1,
                            marginBottom: 1,
                        }}
                    >
                        <LockOutlinedIcon sx={{ color: 'white' }} />
                    </Box> */}

                    <Typography component="h1" variant="h5" sx={{ mb: 3 }}>
                        Sign In to Sunex Courier
                    </Typography>

                    {error && (
                        <Alert severity="error" sx={{ width: '100%', mb: 2 }}>
                            {error}
                        </Alert>
                    )}

                    <Box component="form" onSubmit={handleSubmit} sx={{ width: '100%' }}>
                        <FormControl fullWidth margin="normal">
                            <InputLabel>User Type</InputLabel>
                            <Select
                                name="userType"
                                value={formData.userType}
                                onChange={handleChange}
                                required
                            >
                                <MenuItem value="employee">Employee</MenuItem>
                                <MenuItem value="franchise">Franchise</MenuItem>
                                <MenuItem value="customer">Customer</MenuItem>
                            </Select>
                        </FormControl>

                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            label="Username"
                            name="username"
                            autoComplete="username"
                            autoFocus
                            value={formData.username}
                            onChange={handleChange}
                        />

                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Password"
                            type="password"
                            autoComplete="current-password"
                            value={formData.password}
                            onChange={handleChange}
                        />

                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2, py: 1.5 }}
                            disabled={loading}
                        >
                            {loading ? (
                                <CircularProgress size={24} color="inherit" />
                            ) : (
                                'Sign In'
                            )}
                        </Button>
                    </Box>
                </Paper>
            </Box>
        </Container>
    );
};

export default Login; 